import { render, staticRenderFns } from "./setupPlanRubetekRV3434.vue?vue&type=template&id=5528a93c&scoped=true"
import script from "./setupPlanRubetekRV3434.vue?vue&type=script&lang=js"
export * from "./setupPlanRubetekRV3434.vue?vue&type=script&lang=js"
import style0 from "./setupPlanRubetekRV3434.vue?vue&type=style&index=0&id=5528a93c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5528a93c",
  null
  
)

export default component.exports